module.exports = function() {
  return new Worker(__webpack_public_path__ + "52278d1155f093d4d3dd.worker.js");
};